var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2719 3.98273V4.53858L12.8672 0.803158V0.247314L19.2719 3.98273Z",
    fill: "#FF2727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8672 0.247314L2.54451 12.7191L19.2719 4.53858V3.98273L12.8672 0.247314Z",
    fill: "#FF8A8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97501 13.4971L7.34299 12.1351L6.2523 20.39L3.90489 21.7528L4.97501 13.4971Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97516 13.4971L2.62775 12.1351L1.55763 20.39L3.90504 21.7528L4.97516 13.4971Z",
    fill: "#161616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52472 14.3412L11.8724 11.1019V6.09558L0.455222 11.9671L4.52472 14.3412Z",
    fill: "#393939"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52472 11.6157L11.8724 6.09567L7.80287 3.7215L0.455222 9.24234L4.52472 11.6157Z",
    fill: "#838383"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5244 11.6156V14.3411L0.454899 11.967V9.24219L4.5244 11.6156Z",
    fill: "#272727"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21447 15.2482L4.56264 16.611L4.0272 20.7131L1.67979 19.3503L2.21447 15.2482Z",
    fill: "#F7900B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93272 15.2377L4.56246 16.6112L4.02702 20.7133L6.37519 19.3505L6.93272 15.2377Z",
    fill: "#FFB700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.705a7a8e03caf3c5efb8d83134fb1052.svg";
export { ForwardRef as ReactComponent };